module.exports = __webpack_public_path__ + "main/assets/public/social-icons/instagram.fc12047d31c9d265.svg";